import React, { createContext, useState, useEffect, ReactNode } from "react"
import { getAuth, onAuthStateChanged, User } from "firebase/auth"
import { app } from "@/common/lib/firebase/firebase"

export interface AuthContextType {
    user: User | null
    loading: boolean
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [user, setUser] = useState<User | null>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const auth = getAuth(app)
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user)
            setLoading(false)
        })

        return () => unsubscribe()
    }, [])

    return (
        <AuthContext.Provider value={{ user, loading }}>
            {children}
        </AuthContext.Provider>
    )
}
